'use strict';

var styled = require('styled-components');
var getThemeByProps = require('@userzoomlibraries/toolkit-theme-manager/get-theme-by-props');
var React = require('react');
var isDefinedAndNotNull = require('@userzoomlibraries/toolkit-js-utils/is-defined-and-not-null');
var isFunction = require('@userzoomlibraries/toolkit-js-utils/is-function');
var useFocusable = require('@userzoomlibraries/toolkit-react-utils/use-focusable');
var useAriaAttributes = require('@userzoomlibraries/toolkit-react-utils/use-aria-attributes');
var useDataAttributes = require('@userzoomlibraries/toolkit-react-utils/use-data-attributes');
var useProps = require('@userzoomlibraries/toolkit-react-utils/use-props');
var index_styled = require('./index.styled8.js');
var jsxRuntime = require('react/jsx-runtime');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultCompat(styled);
var getThemeByProps__default = /*#__PURE__*/_interopDefaultCompat(getThemeByProps);
var React__default = /*#__PURE__*/_interopDefaultCompat(React);
var isDefinedAndNotNull__default = /*#__PURE__*/_interopDefaultCompat(isDefinedAndNotNull);
var isFunction__default = /*#__PURE__*/_interopDefaultCompat(isFunction);
var useFocusable__default = /*#__PURE__*/_interopDefaultCompat(useFocusable);
var useAriaAttributes__default = /*#__PURE__*/_interopDefaultCompat(useAriaAttributes);
var useDataAttributes__default = /*#__PURE__*/_interopDefaultCompat(useDataAttributes);
var useProps__default = /*#__PURE__*/_interopDefaultCompat(useProps);

var _excluded = ["className", "prefix", "suffix", "invalid", "onFocus", "onBlur", "onChange"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var InputGeneric$1 = /*#__PURE__*/React__default["default"].forwardRef(function (_ref, ref) {
  var className = _ref.className,
      prefix = _ref.prefix,
      suffix = _ref.suffix,
      invalid = _ref.invalid,
      onFocus = _ref.onFocus,
      onBlur = _ref.onBlur,
      onChange = _ref.onChange,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  var ariaAttributes = useAriaAttributes__default["default"](otherProps, {
    excludedAttributes: ['aria-disabled', 'aria-invalid']
  });
  var dataAttributes = useDataAttributes__default["default"](otherProps);
  var inputProps = useProps__default["default"](otherProps, {
    excluded: ['data-*', 'aria-*']
  });
  var inputGenericRef = React.useRef();
  var innerInputRef = React.useRef(); // Focusable props for input

  var inputFocusableProps = useFocusable__default["default"](innerInputRef.current, inputProps); // Only apply the focusable props for the container if the input is disabled to be able to focus it

  var containerFocusableProps = inputFocusableProps['aria-disabled'] ? {
    'aria-disabled': inputFocusableProps['aria-disabled'],
    tabIndex: inputFocusableProps.tabIndex
  } : {};
  var prefixToProcess = React.useMemo(function () {
    if (isDefinedAndNotNull__default["default"](prefix)) {
      if (isFunction__default["default"](prefix)) {
        return prefix;
      }

      return function () {
        return prefix;
      };
    }

    return null;
  }, [prefix]);
  var suffixToProcess = React.useMemo(function () {
    if (isDefinedAndNotNull__default["default"](suffix)) {
      if (isFunction__default["default"](suffix)) {
        return suffix;
      }

      return function () {
        return suffix;
      };
    }

    return null;
  }, [suffix]);
  var onChangeHandler = React.useCallback(function (event) {
    var target = event.target;
    var newValue = target.value;
    onChange({
      event: event,
      value: newValue
    });
  }, [onChange]);
  React.useImperativeHandle(ref, function () {
    return inputGenericRef.current;
  });
  return /*#__PURE__*/jsxRuntime.jsxs(index_styled.Container, _objectSpread(_objectSpread({
    ref: inputGenericRef,
    className: "gz-input-wrapper ".concat(className),
    "aria-invalid": invalid // eslint-disable-next-line react/jsx-props-no-spreading

  }, containerFocusableProps), {}, {
    children: [prefixToProcess && /*#__PURE__*/jsxRuntime.jsx(index_styled.Prefix, {
      children: prefixToProcess({
        disabled: inputProps.disabled,
        invalid: invalid,
        value: inputProps.value
      })
    }), /*#__PURE__*/jsxRuntime.jsx("input", _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({
      ref: innerInputRef,
      className: "gz-input",
      onFocus: onFocus,
      onBlur: onBlur,
      onChange: onChangeHandler // eslint-disable-next-line react/jsx-props-no-spreading

    }, inputProps), ariaAttributes), dataAttributes), inputFocusableProps), {}, {
      disabled: inputProps.disabled
    })), suffixToProcess && /*#__PURE__*/jsxRuntime.jsx(index_styled.Suffix, {
      children: suffixToProcess({
        disabled: inputProps.disabled,
        invalid: invalid,
        value: inputProps.value
      })
    })]
  }));
});
InputGeneric$1.COMPONENT_ID = 'Gearz.Input.Generic';
InputGeneric$1.displayName = InputGeneric$1.COMPONENT_ID;
InputGeneric$1.propTypes = _objectSpread({}, index_styled.COMMON_PROP_TYPES);
InputGeneric$1.defaultProps = _objectSpread({}, index_styled.COMMON_DEFAULT_PROPS);

/**
 * @license
 * This source code is and remains the property of UserZoom Technologies Inc (sucursal en España).
 * Dissemination of this information or reproduction of this material is strictly
 * forbidden unless prior written permission is obtained from
 * UserZoom Technologies Inc (sucursal en España) (https://www.userzoom.com).
 */
var InputGeneric = styled__default["default"](InputGeneric$1).withConfig({
  componentId: "gz-input-1675939611112__sc-11b4wmx-0"
})(["&[aria-disabled=\"true\"]{cursor:not-allowed;opacity:0.42;}.gz-input{&:disabled{pointer-events:none;}}", ""], function (props) {
  return getThemeByProps__default["default"]({
    componentId: InputGeneric$1.COMPONENT_ID,
    props: props
  });
});
InputGeneric.displayName = InputGeneric$1.displayName;
InputGeneric.propTypes = InputGeneric$1.propTypes;
InputGeneric.defaultProps = InputGeneric$1.defaultProps;

exports.InputGeneric = InputGeneric;
